import Vue from "vue";
import VueRouter from "vue-router";
import mainLayout from "@/components/mainLayout";
import index from "./modules/index";
import manage from "./modules/manage";
import order from "./modules/order";
import authorize from "./modules/authorize";
import journal from "./modules/journal";
import info from "./modules/info";
import version from "./modules/version";
import set from "./modules/set";
import combo from "./modules/combo";
import feedback from "./modules/feedback";
Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            path: '/admin',
            meta: { title: '首页' },
            component: mainLayout,
            children: [
                ...index,
                ...manage,
                order,
                ...authorize,
                ...journal,
                ...info,
                ...version,
                set,
                combo,
                ...feedback,
            ]
        },
        {
            name: '登录',
            path: '/',
            component: () => import("@/pages/login/login.vue")
        }
    ]
})
router.beforeEach((to, from, next) => {
    window.document.title = "溯源平台系统";
    next();
})
export default router;